module.exports = __webpack_public_path__ + "media/images/kids4-cd63bd68aa4dda4ec61a03b8fa188c3f.jpg";